// extracted by mini-css-extract-plugin
module.exports = {"terms":"VerificationTermsAndConditions_terms__RZO_I"};